import React, {Fragment } from "react";
import * as _ from "lodash";
import { Grid, Typography } from "@material-ui/core";
import BodyCashier from "./BodyCashier";
import HeaderCashier from "./HeaderCashier";
import FooterCashier from "./FooterCashier";

function ReadyCashiarCon(props) {
    const {locInv, found, sta, inv, data, onUnmountComplete,premiApp  } = props;

    return (
        <Typography component="div" justifyContent='center'>
        <Grid item  justifyContent='center'>
            <Fragment>
            <HeaderCashier info={found} locInv={locInv} />
                <BodyCashier
                    sta={sta}
                    locInv={locInv}
                    premiApp={premiApp}
                    data={data ?? []}

                />
                <FooterCashier
                    inv={inv}
                    locInv={locInv}
                    found={found}
                />
            </Fragment>
        </Grid>
        </Typography>
    );
}
export default ReadyCashiarCon;
